// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_v1-0";
export var checkoutRateBadgeLink = "_v1-1";